// TODO: add service constant and refactor names

export const SET_NOTIFICATION_STATE = 'SET_NOTIFICATION_STATE'
export const CLEAR_NOTIFICATION_STATE = 'CLEAR_NOTIFICATION_STATE'
export const SET_ERROR_NOTIFICATION = 'SET_ERROR_NOTIFICATION'
export const CLEAR_ERROR_NOTIFICATION = 'CLEAR_ERROR_NOTIFICATION'
